import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, formatDetail } from "../lib/api";

export default function Register() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ full_name: "", email: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user && typeof user === "object") return <Navigate to="/portal" replace />;

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.password.length < 8) return setError("Password must be at least 8 characters.");
    if (f.password !== f.confirm) return setError("Passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", {
        full_name: f.full_name, email: f.email, password: f.password,
      });
      if (data.token) localStorage.setItem("saviar_token", data.token);
      await login(f.email, f.password);
      nav("/portal");
    } catch (err) {
      setError(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="form-section" data-testid="register-page">
      <div className="form-wrap">
        <Link to="/" className="brand-mark" style={{ display: "inline-block", marginBottom: 40 }}>SAVIAR</Link>
        <p className="eyebrow eyebrow-light">Create Account</p>
        <h1 style={{ fontFamily: "var(--serif)", fontSize: "clamp(2rem, 4vw, 3rem)", fontWeight: 300, color: "var(--ivory)", margin: "16px 0 12px" }}>Begin softly.</h1>
        <p style={{ color: "rgba(250,246,238,.5)", marginBottom: 40, fontSize: ".92rem" }}>Create your Saviar portal account.</p>
        <form onSubmit={submit} data-testid="register-form">
          <div className="form-group"><label>Full Name</label><input type="text" required value={f.full_name} onChange={set("full_name")} data-testid="reg-name" /></div>
          <div className="form-group"><label>Email</label><input type="email" required value={f.email} onChange={set("email")} data-testid="reg-email" /></div>
          <div className="form-group"><label>Password</label><input type="password" required value={f.password} onChange={set("password")} data-testid="reg-password" /></div>
          <div className="form-group"><label>Confirm Password</label><input type="password" required value={f.confirm} onChange={set("confirm")} data-testid="reg-confirm" /></div>
          {error && <p style={{ color: "#e08b8b", fontSize: ".85rem", marginBottom: 16 }} data-testid="reg-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn btn-primary" style={{ width: "100%" }} data-testid="reg-submit">
            {busy ? "Creating…" : "Create Account"}
          </button>
        </form>
        <p style={{ marginTop: 24, color: "rgba(250,246,238,.5)", fontSize: ".85rem" }}>
          Already have an account? <Link to="/login" style={{ color: "var(--gold-light)" }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
